/* eslint-disable react-hooks/exhaustive-deps */
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  Home,
  Panel,
  Users,
  NewUser,
  NewInstitutions,
  Institutions,
  SeeInstitution,
  SeeUser,
  SignOut,
  Profile,
  Plans,
  EditPlan,
  NewPlan,
  Payments,
  SeeMyInstitution,
  // PlansPublic,
  InstitutionsPublic,
  SportsPublic,
  ManageSports,
  UpdateInstitution,
  HelpPublic,
  MyDashboard,
  MyQuotas,
  MyUsers,
  MySports,
  MyAdmins,
  MyPlan,
  MyPaymens,
  SeeMyUser,
} from "../pages";
import { PageLayout } from "../layouts/PageLayout/PageLayout";
import AuthGuard from "./AuthGuard";
import { useVerifyRol } from "../hooks/useVerifyRols";

const RouterApp = () => {
  const { verifyRol } = useVerifyRol();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PageLayout />}>
          <Route index element={<Home />} />
          <Route path="sports" element={<SportsPublic />} />
          <Route path="institutions" element={<InstitutionsPublic />} />
          {/* <Route path="plans" element={<PlansPublic />} /> */}
          <Route path="help" element={<HelpPublic />} />

          <Route element={<AuthGuard />}>
            <Route path="/panel" element={<Panel />}>
              <Route path="*" element={<Navigate to="/panel" />} />
              <Route path="" element={<Profile />} />

              {verifyRol({ A: true, U: true }) && (
                <>
                  <Route path="institution" element={<SeeMyInstitution />} />
                  <Route path="dashboard" element={<MyDashboard />} />
                  <Route path="quota" element={<MyQuotas />} />
                  <Route path="users" element={<MyUsers />} />
                  <Route path="users/:userId" element={<SeeMyUser />} />
                  <Route path="sports" element={<MySports />} />
                  <Route path="admins" element={<MyAdmins />} />
                  <Route path="plan" element={<MyPlan />} />
                  <Route path="payments" element={<MyPaymens />} />
                </>
              )}

              {verifyRol({ SA: true }) && (
                <>
                  <Route path="admin/plans" element={<Plans />} />
                  <Route path="admin/plans/:planId" element={<EditPlan />} />
                  <Route path="admin/plans/new" element={<NewPlan />} />
                </>
              )}

              {verifyRol({ SA: true, A: true }) && (
                <>
                  <Route
                    path="admin/manage-sports"
                    element={<ManageSports />}
                  />
                  <Route path="admin/institutions" element={<Institutions />} />
                  <Route
                    path="admin/institutions/new"
                    element={<NewInstitutions />}
                  />
                  <Route
                    path="admin/institutions/:institutionId"
                    element={<SeeInstitution />}
                  />
                  <Route
                    path="admin/institutions/:institutionId/update"
                    element={<UpdateInstitution />}
                  />
                  <Route path="admin/payments" element={<Payments />} />
                </>
              )}
              {verifyRol({ A: true }) && (
                <>
                  <Route path="admin/users" element={<Users />} />
                  <Route path="admin/users/new" element={<NewUser />} />
                  <Route path="admin/users/:userId" element={<SeeUser />} />
                </>
              )}
            </Route>

            <Route path="profile" element={<Profile />} />
            <Route path="signout" element={<SignOut />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};
export default RouterApp;
